<template>
    <div class="card clickable" width="50%" id ="case-list-card">
        <img :src="c.img" class="card-img-top" :alt="c.name">
        <div class="card-body">
        <h5 class="card-title">{{ c.name }}</h5>
        <p class="card-text">{{ c.year }} {{ c.district }}</p>
        <p class="card-text"><small class="text-muted">{{ c.plan }}</small></p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CaseListCard',
  props: {
    c: Object,
  },
}
</script>

<style scoped>
</style>